import React, { FC } from "react";
import { IBreadCrumbsItem } from "./types";
import { Link } from "../Link";
import { useTranslation } from "react-i18next";

export const BreadCrumbsItem: FC<IBreadCrumbsItem> = ({
  title,
  path,
  isDisabled,
  isHidden,
}) => {
  const { t } = useTranslation();

  const translatedTitle =
    typeof title === "string" ? title : t(title.i18nKey, title.i18nParams);

  if (isHidden) return null;

  return (
    <li className="capitalize text-purple-base text-lg group max-w-50 truncate">
      {isDisabled || !path ? (
        <div className="font-bold truncate">{translatedTitle}</div>
      ) : (
        <div className="flex items-center truncate">
          <Link href={path}>
            <div className="flex items-center truncate">
              <div className="truncate transition-all duration-200 group-hover:text-purple-dark">
                {translatedTitle}
              </div>
            </div>
          </Link>
          <span className="mx-1">•</span>
        </div>
      )}
    </li>
  );
};
